import type { AiProposal } from '@/types/ai-proposal';

export interface AiProposalsAdapter {
  getState: () => {
    reapplyPendingPreviews: () => void;
    rejectMany: (ids: string[]) => Promise<void>;
    proposals: AiProposal[];
  };
}

let adapter: AiProposalsAdapter | null = null;

export const registerAiProposalsAdapter = (store: AiProposalsAdapter): void => {
  adapter = store;
};

export const getAiProposalsAdapter = (): AiProposalsAdapter | null => adapter;

export const clearAiProposalsAdapter = (): void => {
  adapter = null;
};
